<template>
  <div
    :class="{
      'cursor-wait': loading,
      'cursor-not-allowed': disabled,
    }"
  >
    <button
      :id="id"
      :type="type"
      :name="name"
      :class="['w-full', buttonVariant, { loading: loading }, { disabled: disabled }]"
      @click="onClick"
      :disabled="disabled || loading"
    >
      <Loader v-if="loading" />
      <span v-else>{{ label }}</span>
    </button>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';

export default {
  name: 'Button',
  components: {
    Loader,
  },
  props: {
    id: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      default: 'button',
    },
    name: {
      type: String,
      default: 'name',
    },
    color: {
      type: String,
      default: 'primary',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  emits: ['click'],
  computed: {
    buttonVariant() {
      return `tcsmd-btn-${this.color}`;
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>
